import Spinner from 'react-bootstrap/Spinner';
import styles from '../styles/Spinner.module.css'

const CustomSpinner = ({ children }) => {
  return (
    <div className={styles.loading}>
        <Spinner animation="border" role="status"></Spinner>
    </div>
  );
}

export default CustomSpinner;